import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';
import { saveSuperUserDraft, retrieveSuperUserDraft } from './actions';
import { SAVE_AS_DRAFT, RETRIEVE_DRAFT } from './constants';

const tindraftSelector = (state) => {
  return state.superUserDraft;
};

export const useTinDrafts = {
  state: () => {
    return useSelect(tindraftSelector);
  },
  actions: () => {
    return {
      saveSuperUserDraft: useAction(saveSuperUserDraft, {
        saga: useAsync(SAVE_AS_DRAFT),
      }),
      retrieveSuperUserDraft: useAction(retrieveSuperUserDraft, {
        saga: useAsync(RETRIEVE_DRAFT),
      }),
    };
  },
};
